import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function buildUrlWithQuery(
  url: string,
  params: Record<string, string | number | boolean | null | undefined>,
): string {
  const [baseWithQuery, hashPart] = url.split("#");
  const [basePath, currentQuery = ""] = baseWithQuery.split("?");

  const searchParams = new URLSearchParams(currentQuery);

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      searchParams.delete(key);
    } else {
      searchParams.set(key, String(value));
    }
  }

  const query = searchParams.toString();
  return `${basePath}${query ? `?${query}` : ""}${hashPart ? `#${hashPart}` : ""}`;
}
